

import { Typography, Button, Box } from "@mui/material";
import { Cancel } from "@mui/icons-material";
import { useState } from "react";

const FailureData = {
  error: {
    code: "card_declined",
    doc_url: "https://stripe.com/docs/error-codes/card-declined",
    message: "Your card was declined.",
    param: "payment_method",
    payment_intent: {
      id: "pi_3XYZ123",
      object: "payment_intent",
      amount: 5000,
      currency: "usd",
      status: "requires_payment_method",
      last_payment_error: {
        code: "card_declined",
        message: "Your card was declined.",
        type: "card_error",
      },
    },
    type: "card_error",
  },
};

const Failure = () => {
  const [isFailureData, _setFailureData] = useState(FailureData);

  return (
    <Box
      sx={{
        backgroundColor: "#fff8f8",
        width: "100vw",
        height: "100vh",
        display: "inline-block",
        alignContent: "center",
      }}
    >
      <Box
        textAlign="center"
        mt={0}
        sx={{
          backgroundColor: "#fff",
          width: "fit-content",
          margin: "0 auto",
          padding: "20px",
          borderRadius: "10px",
          boxShadow: "0px 2px 8px #adadad",
          maxWidth: "400px",
        }}
      >
        <>
          <Cancel sx={{ fontSize: 60, color: "red" }} />
          <Typography
            variant="h5"
            sx={{ color: "red", fontWeight: "bold", mt: 1 }}
          >
            Payment Failed ❌
          </Typography>
          <Typography variant="body1" sx={{ mt: 1 }}>
            Oops! <b>{isFailureData.error.message}</b>
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
            Please check your payment details or try a different payment method.
            If the issue persists, contact support.
          </Typography>
          <Box mt={2}>
            <Button variant="contained" color="error" sx={{ width: "auto" }}>
              Try Again
            </Button>
          </Box>
        </>
      </Box>
    </Box>
  );
};

export default Failure;
